import React, { useState } from 'react';

import {
  DeviceOS,
  MemberContactMethodType,
} from '@vestahealthcare/common/enums';
import { translate } from '@vestahealthcare/common/i18n';
import { Patient } from '@vestahealthcare/common/models';
import { EMPTY } from '@vestahealthcare/common/utils/constants';
import { format } from '@vestahealthcare/common/utils/phone';

import { Invite, Modal } from 'styleguide-v2';

type Props = {
  member?: Patient;
  onSendAppInvite: (member: Patient, deviceOs: DeviceOS) => Promise<void>;
};

export const MemberSelfReporterDetails = ({
  member,
  onSendAppInvite,
}: Props) => {
  const { appUser, hciReporter, hciReporterStatus, hciReporterMethod } =
    member ?? {};

  const [showInviteModal, setShowInviteModal] = useState<boolean>(false);
  const [showInviteModalType, setShowInviteModalType] = useState<DeviceOS>();

  if (!member) return <>{EMPTY}</>;

  return (
    <div className="flex gap wrap">
      <div>
        <p className="no-margin">
          {translate(`global.${hciReporter ? 'yes' : 'no'}`)}{' '}
          {hciReporter && (
            <span className="small">
              [{hciReporterStatus?.description || translate('global.new')}]
            </span>
          )}
        </p>

        {hciReporterMethod && (
          <p className="no-margin">{hciReporterMethod.toString()}</p>
        )}
      </div>

      {hciReporter &&
        hciReporterMethod === MemberContactMethodType.MOBILE_APP_CHAT &&
        appUser?.authenticationPhone &&
        !appUser?.lastLoginAt && (
          <>
            <br />
            <div className="flex gap wrap">
              <Invite
                sent={appUser.inviteOS === DeviceOS.IOS}
                type="ios"
                onClick={() => {
                  setShowInviteModalType(DeviceOS.IOS);
                  setShowInviteModal(true);
                }}
              />
              <Invite
                sent={appUser.inviteOS === DeviceOS.ANDROID}
                type="android"
                onClick={() => {
                  setShowInviteModalType(DeviceOS.ANDROID);
                  setShowInviteModal(true);
                }}
              />
            </div>

            <Modal
              onClose={() => setShowInviteModal(false)}
              onSubmit={async () => {
                if (!member || !showInviteModalType) return;
                await onSendAppInvite(member, showInviteModalType);
              }}
              submitText={translate('global.send')}
              open={!!showInviteModal}
              title={translate(
                'personalDetails.programDetailsCard.selfReporterModal.sendAppInvite',
              )}
              body={translate(
                'personalDetails.programDetailsCard.selfReporterModal.sendAppInviteBody',
                {
                  member: member.fullName,
                  number: format(appUser.authenticationPhone.number),
                  os: showInviteModalType?.toString(),
                },
              )}
            />
          </>
        )}
    </div>
  );
};
